import { Button, Icon, Modal } from 'semantic-ui-react'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ProvisionDevice } from '../../../services/device'
import { RefreshCustomerDeviceList } from '../../../redux/actions/devices'
import StatusDialog from '../../status-dialog'
import { store } from '../../../redux/store'
import classes from './confirm-dialog.module.css'
import styles from '../asset-mangament/create-asset/asset-modal.module.css'
import IntelMsg from '../../ItelMsg'

const { dispatch } = store

const ProvisionConfirmDialog = ({
  showConfirmDialog,
  setShowConfirmDialog,
  device,
}) => {
  const [showStatusErrorDialog, setShowStatusDialog] = useState(false)
  const [statusDialogContent, setStatusDialogContent] = useState()
  const { productName, userEmail } = useSelector((reduxStore) => ({
    productName: reduxStore.product.productName,
    userEmail: reduxStore.auth.userEmail,
  }))
  const { t } = useTranslation()
  const confirmProvision = () => {
    ProvisionDevice(productName, userEmail, device).then((response) => {
      setShowConfirmDialog(false)
      if (response.success) {
        dispatch(RefreshCustomerDeviceList(true))
      } else {
        setStatusDialogContent(response.msg)
        setShowStatusDialog(true)
      }
    })
  }
  return (
    <>
      <Modal
        open={showConfirmDialog}
        size="small"
        style={{ position: 'relative', height: 'auto' }}
      >
        <Modal.Header closeButton className={styles.header}>
          <IntelMsg id="provisioningConfirmDialogHeader" />
        </Modal.Header>
        <Modal.Content scrolling>
          <Icon name="configure" size="huge" />
          <span style={{ fontSize: 'x-large' }}>
            <IntelMsg id="provisioningConfirmDialogMessage" />
          </span>
        </Modal.Content>
        <Modal.Actions>
          <Button
            form="deviceAddForm"
            className={classes.positiveStatus}
            onClick={() => {
              confirmProvision()
            }}
          >
            <IntelMsg id="provisioningConfirmDialogBtn" />
          </Button>
          <Button
            className={classes.negativeStatus}
            onClick={() => {
              setShowConfirmDialog(false)
            }}
          >
            <IntelMsg id="provisioningConfirmDialogNoBtn" />
          </Button>
        </Modal.Actions>
      </Modal>
      <StatusDialog
        showDialog={showStatusErrorDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={t('provisioningConfirmDialogErrorHeader')}
        dialogContent={
          <>
            <Icon name="exclamation triangle" size="huge" color="red" />
            <p style={{ fontSize: 'x-large' }}>{statusDialogContent}</p>
          </>
        }
      />
    </>
  )
}

ProvisionConfirmDialog.propTypes = {
  device: PropTypes.string.isRequired,
  showConfirmDialog: PropTypes.bool.isRequired,
  setShowConfirmDialog: PropTypes.func.isRequired,
}

export default ProvisionConfirmDialog
